import useBodyScroll from "../hooks/use-body-scroll";

export default useBodyScroll;
